import styled from 'styled-components'
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap'

import FailedExternalSurveyModalStyles from './FailedExternalSurveyStyles'

const CustomStyles = {
  'failed-external-survey': FailedExternalSurveyModalStyles,
}

export const StyledModal = styled(Modal)`
  &&& {
    ${(props) => (props.mode ? CustomStyles[props.mode].Modal : '')}
  }
`

export const StyledModalHeader = styled(ModalHeader)`
  &&& {
    ${(props) => (props.mode ? CustomStyles[props.mode].ModalHeader : '')}
  }
`

export const StyledModalBody = styled(ModalBody)`
  &&& {
    ${(props) => (props.mode ? CustomStyles[props.mode].ModalBody : '')}
  }
`

export const StyledModalFooter = styled(ModalFooter)`
  &&& {
    ${(props) => (props.mode ? CustomStyles[props.mode].ModalFooter : '')}
  }
`

export const StyledButton = styled(Button)`
  &&& {
    ${(props) => (props.mode ? CustomStyles[props.mode].Button : '')}
  }
`

export const StyledSecondButton = styled(Button)`
  &&& {
    ${(props) => (props.mode ? CustomStyles[props.mode].SecondButton : '')}
  }
`

export const StyledModalImage = styled.img`
  ${(props) => (props.mode ? CustomStyles[props.mode].img : '')}
`
